
import {serializable, alias, object, list, primitive} from 'serializr';

export class Role { 

	@serializable(alias('id', primitive()))
	id?: number;

	@serializable(alias('name', primitive()))
	name?: string;
	
	@serializable(alias('id', primitive()))
	value?: number;

	@serializable(alias('name', primitive()))
	label?: string;

}